import PropTypes from 'prop-types'

// eslint-disable-next-line complexity
const ProductImage = ({
  alt,
  ariaHideAnchor,
  className,
  divClassName,
  onClickHandler,
  productTitle,
  productUrl,
  url,
  width
}) => {
  let src = url
  if (window.environment !== 'test') {
    src = url === '/' ? url : `${url}/width/${width}?style=preview`
  }

  return (
    <div className={divClassName ? divClassName : null}>
      <Choose>
        <When condition={productUrl}>
          <a
            aria-label={productTitle}
            href={productUrl}
            onClick={onClickHandler || undefined}
            {...(ariaHideAnchor && { "aria-hidden": true, tabIndex: "-1" })}
          >
            <img
              alt={alt ? alt : ''}
              className={className}
              src={src}
            />
          </a>
        </When>
        <Otherwise>
          <img
            alt={alt ? alt : ''}
            className={className}
            src={src}
          />
        </Otherwise>
      </Choose>
    </div>
  )
}

ProductImage.propTypes = {
  alt: PropTypes.string,
  ariaHideAnchor: PropTypes.bool,
  className: PropTypes.string,
  divClassName: PropTypes.string,
  onClickHandler: PropTypes.func,
  productTitle: PropTypes.string,
  productUrl: PropTypes.string,
  url: PropTypes.string.isRequired,
  width: PropTypes.number
}

ProductImage.defaultProps = {
  ariaHideAnchor: false,
  className: 'tile_image',
  divClassName: 'product-cover',
  width: 200
}

export default ProductImage
